export const REHAB_GUIDANCE_SYSTEM_TYPE = '康复指导VIP'

export default {
  REHAB_GUIDANCE_SYSTEM_TYPE
}
